import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
// This component handles smooth scrolling to anchor links and adjusts for header height
export default function ScrollToAnchor() {
  const location = useLocation();
  const lastHashRef = useRef('');
  useEffect(() => {
    // Check if there's a hash in the URL
    if (location.hash) {
      lastHashRef.current = location.hash.slice(1); // Remove the # character
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        const element = document.getElementById(lastHashRef.current);
        if (element) {
          // Get header height to offset scroll position
          const header = document.querySelector('header');
          const headerHeight = header ? header.offsetHeight : 0;
          // Calculate position with offset
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerHeight - 20;
          // Scroll to element with smooth behavior
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, [location]);
  return null;
}